import { useMemo } from "react";
import { Paper, Stack, Text } from "@mantine/core";
import {
  formatLegacyDate,
  type LegacyReviewValues,
} from "../../../utils/legacyReviewForm";

export default function LegacyPatientImportSummary({
  values,
}: {
  values: LegacyReviewValues;
}) {
  const identity = useMemo(
    () =>
      values.patientAction === "match"
        ? values.patientReviewedIdentity
        : values,
    [values]
  );
  return (
    <Paper withBorder p="sm" style={{ overflowWrap: "anywhere" }}>
      <Stack gap={4}>
        <Text fw={600}>
          {values.patientAction === "match"
            ? "Link to existing patient"
            : "Create a new patient"}
        </Text>
        <Text>
          {identity?.lastName}, {identity?.firstName}
        </Text>
        <Text size="sm">
          Date of birth: {formatLegacyDate(identity?.dateOfBirth)}
        </Text>
        <Text size="sm">Sex: {identity?.sex || "Not provided"}</Text>
        <Text size="sm">
          MRN: {identity?.medicalRecordNumber || "Not provided"}
        </Text>
        {values.patientAction === "match" && (
          <Text size="sm" c="dimmed">
            Current LIS demographics and the historical report will stay
            unchanged.
          </Text>
        )}
      </Stack>
    </Paper>
  );
}
